import { reactive } from "vue";

const state = reactive({
  visible: false,
  message: "",
  detail: "",
  variant: "info" as "success" | "error" | "info",
  timeoutId: null as number | null,
  showDelayId: null as number | null,
  action: null as { label: string; handler: () => void } | null,
});

export function useSnackbar() {
  function clearTimers() {
    if (state.timeoutId) {
      clearTimeout(state.timeoutId);
      state.timeoutId = null;
    }
    if (state.showDelayId) {
      clearTimeout(state.showDelayId);
      state.showDelayId = null;
    }
  }

  function show(
    message: string,
    options?: {
      detail?: string;
      variant?: "success" | "error" | "info";
      duration?: number;
      delay?: number;
      action?: { label: string; handler: () => void };
    }
  ) {
    clearTimers();
    state.message = message;
    state.detail = options?.detail || "";
    state.variant = options?.variant || "info";
    state.action = options?.action || null;
    // Start hidden and set a small delay before showing to allow transition to apply smoothly
    state.visible = false;
    const delay = typeof options?.delay === "number" ? options!.delay : 20;
    state.showDelayId = window.setTimeout(() => {
      state.visible = true;
      state.showDelayId = null;
    }, delay);

    const duration = options?.duration ?? 4000;
    state.timeoutId = window.setTimeout(() => {
      state.visible = false;
      state.timeoutId = null;
    }, duration + delay);
  }

  function hide() {
    clearTimers();
    state.visible = false;
  }

  return { state, show, hide };
}

export const snackbarState = state;
